"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RE_SOURCE_MAPPING_URL = exports.RE_VALID_FRAME_FIREFOX = exports.RE_VALID_FRAME_CHROME = void 0;
// Stack frame parsing related reg-exps
const RE_VALID_FRAME_CHROME = /^\s*(at|in)\s.+(:\d+)/;
exports.RE_VALID_FRAME_CHROME = RE_VALID_FRAME_CHROME;
const RE_VALID_FRAME_FIREFOX = /(^|\/?@)\S+:\d+|.+line\s+\d+\s+>\s+(eval|Function).+/;
exports.RE_VALID_FRAME_FIREFOX = RE_VALID_FRAME_FIREFOX;
/**
 * Used to extract source mapping url injected at the end
 * of a file with generated source maps (in separate file).
 */
const RE_SOURCE_MAPPING_URL = /\/\/[#@] ?sourceMappingURL=([^\s'"]+)\s*$/gm;
exports.RE_SOURCE_MAPPING_URL = RE_SOURCE_MAPPING_URL;